import { FormattedMessage } from "react-intl";
import "../../assets/styles/footer.css";
import React from "react";
import en_locale from "../../translations/en.json";
import de_locale from "../../translations/de.json";
import { useSelector } from "react-redux";

const Footer = () => {
  const lang = useSelector((state) => state.settings.lang);
  const messages = {
    de: de_locale,
    en: en_locale,
  };
  return (
    <>
      <footer className="page-footer">
        <div className="footer content">
          <div
            data-content-type="html"
            data-appearance="default"
            data-element="main"
            data-pb-style="VDR00OB"
            data-decoded="true"
          >
            <div className="col2">
              <h4>
                <FormattedMessage id="PRODUCTS" />
              </h4>
              <ul>
                <li className="sub-menu-wrapper">
                  <ul className="sub-menu">
                    <li>
                      <a
                        className="subcat-link"
                        href={messages[lang]["clearVat link"]}
                      >
                        {" "}
                        ClearVAT{" "}
                      </a>
                    </li>
                  </ul>
                  <ul className="sub-menu">
                    <li>
                      <a
                        className="subcat-link"
                        href={messages[lang]["clearCustoms link"]}
                      >
                        {" "}
                        ClearCustoms{" "}
                      </a>
                    </li>
                  </ul>
                  <ul className="sub-menu">
                    <li>
                      <a
                        className="subcat-link"
                        href={messages[lang]["vatRules link"]}
                      >
                        {" "}
                        VATRules{" "}
                      </a>
                    </li>
                  </ul>
                  <ul className="sub-menu">
                    <li>
                      <a
                        className="subcat-link"
                        href={messages[lang]["fileVat link"]}
                      >
                        {" "}
                        FileVAT{" "}
                      </a>
                    </li>
                  </ul>
                  <ul className="sub-menu">
                    <li>
                      <a
                        className="subcat-link"
                        href={messages[lang]["checkVatId link"]}
                      >
                        {" "}
                        CheckVAT ID{" "}
                      </a>
                    </li>
                  </ul>
                  
                </li>
              </ul>
            </div>
            <div className="col2">
            
            </div>
            <div className="col2" />
            <div className="col2">
              <h4>
                <FormattedMessage id="Company" />
              </h4>
              <ul>
                <li className="sub-menu-wrapper">
                  <ul className="sub-menu">
                    <li>
                      <a
                        className="subcat-link"
                        href={messages[lang]["company link"]}
                      >
                        {" "}
                        <FormattedMessage id="About us" />{" "}
                      </a>
                    </li>
                  </ul>
                  <ul className="sub-menu">
                    <li>
                      <a
                        className="subcat-link"
                        href={messages[lang]["managementBoard link"]}
                      >
                        {" "}
                        <FormattedMessage id="Management Board" />{" "}
                      </a>
                    </li>
                  </ul>
                  <ul className="sub-menu">
                    <li>
                      <a
                        className="subcat-link"
                        href={messages[lang]["supervisoryBoard link"]}
                      >
                        {" "}
                        <FormattedMessage id="Supervisory Board" />{" "}
                      </a>
                    </li>
                  </ul>
                  <ul className="sub-menu">
                    <li>
                      <a
                        className="subcat-link"
                        href={messages[lang]["partners link"]}
                      >
                        {" "}
                        <FormattedMessage id="Partners" />{" "}
                      </a>
                    </li>
                  </ul>
                  <ul className="sub-menu">
                    <li>
                      <a
                        className="subcat-link"
                        href={messages[lang]["locations link"]}
                      >
                        {" "}
                        <FormattedMessage id="Locations" />{" "}
                      </a>
                    </li>
                  </ul>
                  <ul className="sub-menu">
                    <li>
                      <a
                        className="subcat-link"
                        href={messages[lang]["career link"]}
                      >
                        {" "}
                        <FormattedMessage id="Career" />{" "}
                      </a>
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
            <div className="col2">
              <h4>Newsroom</h4>
              <ul>
                <li className="sub-menu-wrapper">
                  <ul className="sub-menu">
                    <li>
                      <a
                        className="subcat-link"
                        href={messages[lang]["latestInformation link"]}
                      >
                        {" "}
                        <FormattedMessage id="Current information" />{" "}
                      </a>
                    </li>
                  </ul>
                  <ul className="sub-menu">
                    <li>
                      <a
                        className="subcat-link"
                        href={messages[lang]["newsletter link"]}
                      >
                        {" "}
                        <FormattedMessage id="Newsletter" />{" "}
                      </a>
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
            <div className="col2">
              <h4>Contact</h4>
              <ul>
                <li>
                  <span>eClear AG</span>
                </li>
                <li>
                  <span>Französische Straße 56-60</span>
                </li>
                <li>
                  <span>10117 Berlin, Germany</span>
                </li>
                <br />
                <li>
                  <a href="tel:+493023590710">+49 30 2359071-0</a>
                </li>
                <li>
                  <a href="mailto:info@eclear.com">info@eclear.com</a>
                </li>
                <br />
                <li>
                   <span>WKN: A2AA3A</span>
                </li>
                <li>
                  <span>ISIN: DE000A2AA3A5</span>
                </li>
                <br />
                <li>
                    <img
                    src={require("../../assets/images/Clearstream.png")}
                    alt="Clear Stream"
                  />
                </li>
                <br/>
                <li><span>Supervisory authority:<br/>Federal Financial<br/>Supervisory Authority</span></li>
          
                <br />
                <li>
                  <a href={messages[lang]["contact link"]}>
                    <FormattedMessage id="Contact" />
                  </a>
                </li>
                <li>
                  <a href={messages[lang]["customerSupport link"]}>
                    <FormattedMessage id="Customer Support" />
                  </a>
                </li>
              </ul>
              <br />
              <ul>
                <h4>Social</h4>
                <ul id="menu-social-de" className="">
                  <li className=" menu-item menu-item-type-custom menu-item-object-custom">
                    <a
                      href="https://www.linkedin.com/company/eclear-ag/"
                      target="_self"
                    >
                      <i className="fa fa-linkedin" aria-hidden="true" />
                    </a>
                  </li>
                  <li className=" menu-item menu-item-type-custom menu-item-object-custom">
                    <a
                      href="https://www.xing.com/pages/eclear-ag/"
                      target="_self"
                    >
                      <i className="fa-brands fa-xing" />
                    </a>
                  </li>
                  <li className=" menu-item menu-item-type-custom menu-item-object-custom">
                    <a href="https://www.youtube.com/c/eClearAG" target="_self">
                      <i className="fa-brands fa-youtube" />
                    </a>
                  </li>
                  <li className=" menu-item menu-item-type-custom menu-item-object-custom">
                    <a href="https://twitter.com/eclearag" target="_self">
                      <i className="fa-brands fa-x" />
                    </a>
                  </li>
                  <li className=" menu-item menu-item-type-custom menu-item-object-custom">
                    <a href="https://www.facebook.com/eClearAG" target="_self">
                      <i className="fa fa-facebook-square" aria-hidden="true" />
                    </a>
                  </li>
                  <li className=" menu-item menu-item-type-custom menu-item-object-custom">
                    <a href="https://medium.com/@eClearAG" target="_self">
                      <i className="fa fa-medium" aria-hidden="true" />
                    </a>
                  </li>
                </ul>
              </ul>
            </div>
            <div
              className="d-flex justify-content-end mb-5"
              style={{ paddingTop: 60, paddingBottom: 30 }}
            >
            
              <img
                src={require("../../assets/images/bmbf.webp")}
                alt="BMBF"
                className=" p-3 footer_logo img-fluid"
              />
              <img
                src={require("../../assets/images/idw.webp")}
                alt="IDW"
                className=" p-3 footer_logo img-fluid"
                style={{ width: "6%" }}
              />
              <img
                src={require("../../assets/images/signatory.webp")}
                alt="Signatory"
                className=" p-3 footer_logo img-fluid"
              />
              <img
                src={require("../../assets/images/sap.webp")}
                alt="SAP"
                className=" p-3 footer_logo img-fluid"
              />
               <img
                src={require("../../assets/images/SAP_Partner_transp.png")}
                alt="SAP Partner"
                className=" p-3 footer_logo img-fluid" style={{ width: "6%" }}
              />
            </div>
            <link rel="dns-prefetch" href="//use.fontawesome.com" />
            <link
              rel="stylesheet"
              id="font-awesome-official-v4shim-css"
              href="https://use.fontawesome.com/releases/v6.2.0/css/v4-shims.css"
              media="all"
              integrity="sha384-MAgG0MNwzSXBbmOw4KK9yjMrRaUNSCk3WoZPkzVC1rmhXzerY4gqk/BLNYtdOFCO"
              crossOrigin="anonymous"
            />
            <link
              rel="stylesheet"
              id="font-awesome-official-css"
              href="https://use.fontawesome.com/releases/v6.2.0/css/all.css"
              media="all"
              integrity="sha384-SOnAn/m2fVJCwnbEYgD4xzrPtvsXdElhOVvR8ND1YjB5nhGNwwf7nBQlhfAwHAZC"
              crossOrigin="anonymous"
            />
          </div>
        </div>
      </footer>
      <div
        data-content-type="html"
        data-appearance="default"
        data-element="main"
        data-decoded="true"
      >
        <div className="footer-bottom">
          <div className="container">
            <div className="row">
              <div className="col-md-5">
                {" "}
                <span className="copyright">
                  ©2023 eClear Aktiengesellschaft
                </span>
              </div>
              <div className="col-md-7">
                <ul
                  id="menu-footer-bottom-menu-de"
                  className="footer-bottom-menu"
                >
                  <li className=" menu-item menu-item-type-post_type menu-item-object-page menu-item-privacy-policy">
                    <a
                      href={messages[lang]["privacyPolicy link"]}
                      target="_self"
                    >
                      <FormattedMessage id="Privacy policy" />
                    </a>
                  </li>
                  <li className=" menu-item menu-item-type-post_type menu-item-object-page">
                    <a href={messages[lang]["imprint link"]} target="_self">
                      <FormattedMessage id="Imprint" />
                    </a>
                  </li>
                  <li className=" menu-item menu-item-type-post_type menu-item-object-page current-menu-item page_item page-item-2381 current_page_item">
                    <a href={messages[lang]["contact link"]} target="_self">
                      <FormattedMessage id="Contact" />
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Footer;
